import dayjs from 'dayjs';
import 'dayjs/locale/ru';

dayjs.locale('ru');

export const formatDateForSeparator = (date: Date): string => {
  const now = dayjs();
  const target = dayjs(date);

  if (target.isSame(now, 'day')) {
    return 'Сегодня';
  }

  if (target.isSame(now, 'year')) {
    return target.format('D MMMM');
  }

  return target.format('D MMMM YYYY');
};

export const isSameDay = (date1: Date, date2: Date): boolean => {
  return dayjs(date1).isSame(dayjs(date2), 'day');
};

export type DateSeparatorParams = {
  currentDate: Date;
  prevDate?: Date;
  isFirstMessage: boolean;
  hasMore: boolean;
};

export const shouldShowDateSeparator = ({
  currentDate,
  prevDate,
  isFirstMessage,
  hasMore
}: DateSeparatorParams): boolean => {
  const isDifferentDay = !prevDate || !isSameDay(currentDate, prevDate);
  return isDifferentDay && !(isFirstMessage && hasMore);
};
